<template>
    <div>
        <div class="p-0 m-0 header d-flex align-items-center mb-3">
            <h5 class="">Initiate Payout</h5>
            <div class="ml-auto p-0 m-0">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb p-2">
                        <li class="breadcrumb-item small">
                            <router-link :to="{ name: 'viewpool', params: { pool_id: pool_id }}">My Pool</router-link>
                        </li>
                        <li class="breadcrumb-item active small" aria-current="page">Payout</li>
                    </ol>
                </nav>
            </div>

        </div>

        <div class="mb-2 d-flex" v-if="pool != null">
            <p class="m-0 h6">
                Max Payout: <span class="font-weight-bold text-success">&#8358;{{ pool.contributed_amount | moneyformat }}</span>
            </p>
            <p class="ml-auto m-0"><span class="badge badge-light">{{ pool.payout_rule }}</span></p>
        </div>


        <div v-if="pool != null">

            <organizer-autonomy
                v-if="pool.payout_rule == 'organizer-autonomy'"
                :pool="pool"
                :contributors="contributors">
            </organizer-autonomy>

            <majority-vote
                v-if="pool.payout_rule == 'majority-vote'"
                :pool="pool"
                :contributors="contributors">
            </majority-vote>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrganizerAutonomy from '@/components/OrganizerAutonomy'
import MajorityVote from '@/components/MajorityVote'

export default {
    name: 'InitiatePayout',
    components: {
        OrganizerAutonomy,
        MajorityVote
    },
    data() {
        return {
            pool_id: this.$route.params.pool_id
        }
    },
    computed: {
        ...mapGetters({
            pool: 'pool',
            user: 'user',
            contributors: 'pool_contributors'
        }),
    },
    created() {
        this.$store.dispatch('getPool', this.pool_id);
        this.$store.dispatch('listPaidContributors', this.pool_id);
    },

}
</script>

<style>
.divider { 
    width:50%; 
    /* text-align:center;  */
    border-bottom: 1px solid rgba(0,0,0,.1);
    line-height:0.1em; 
    margin:10px 0 20px; 
} 
.divider span { 
    background:#fff; 
    padding:0 10px; 
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>